import Sidebar from '../../components/Common/Sidebar';
import LenderIqFramework from '../../components/_pages/LenderIq/LenderIq';

const LenderIq = () => {
  return (
    <>
      <Sidebar />
      <LenderIqFramework/>
    </>
  );
};

export default LenderIq;
